module.exports = __webpack_public_path__ + "img/train-tool-hardware.dc2b9aa6.jpeg";